<template>
  <div class="fileUpload">
    <DxFileUploader
      ref="uploader"
      :allowed-file-extensions="allowedFileExtensions"
      :selectButtonText="$t('lecOne.ChooseTheFile')"
      :labelText="$t('lecOne.ChooseTheFileYouWantToUpload')"
      :multiple="true"
      :chunk-size="5000000"
      :max-file-size="209715200"
      name="FileUpload"
      :accept="allowedFileExtensions.join(',')"
      uploadMode="instantly"
      uploadMethod="POST"
      :uploadHeaders="headers"
      :upload-url="`${UploaderUrl}${locationName}`"
      @upload-started="() => (chunks = [])"
      @progress="onUploadProgress($event)"
      @uploaded="onUploaded($event)"
    />
    <v-alert dense text type="info" color="primary">
      <span class="note"
        >{{ $t("lecOne.AllowedFiles") }} :
        <span>
          {{ allowedFileExtensions.join(", ") }} </span
        >.</span
      >
      <span class="note">{{ $t("lecOne.MaximumFileSize") }} : <span>200MB</span></span>
    </v-alert>
  </div>
</template>
<script>
import { mapState } from "vuex";
import DxFileUploader from "devextreme-vue/file-uploader";

export default {
  name: "CustomFileUploader",
  components: {
    DxFileUploader
  },
  props: {
   
    locationName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      chunks: [],
      allowedFileExtensions: [
        ".jpg",
        ".jpeg",
        ".gif",
        ".png",
        ".bmp",
        ".mp4",
        ".wmv",
        ".flv",
        ".avi",
        ".webm",
        ".weba",
        ".wav",
        ".mp3",
        ".aac",
        ".pdf",
        ".doc",
        ".docx",
        ".xls",
        ".xlsx",
        ".ppt",
        ".pptx",
        ".txt",
        ".zip",
        ".rar"
      ]
    };
  },
  computed: {
    ...mapState(["UploaderUrl"])
  },
  methods: {
    onUploaded(e) {
      if (e.request.status === 200) {
        this.$emit("file-uploaded", e);
      } else {
        this.$emit("file-upload-error", e);
      }
      this.chunks = [];
    },
    onUploadProgress(e) {
      this.chunks.push({
        segmentSize: e.segmentSize,
        bytesLoaded: e.bytesLoaded,
        bytesTotal: e.bytesTotal
      });
    }
  }
};
</script>
